import React from 'react';
import { HeaderProps } from './types';
import {
  StyledHeader,
  StyledHeaderAction,
  StyledHeaderActionColumn,
  StyledHeaderTitle,
} from './styles';
import useHeaderTitleContext from '../../../hooks/useHeaderTitleContext';
import MenuDropdown from '../../molecules/MenuDropdown';
import Seo from '../../Seo';

const Header: React.FC<HeaderProps> = ({ menu, centerComponent }) => {
  const { title } = useHeaderTitleContext();

  return (
    <>
      <Seo {...{ title }} />
      <StyledHeader>
        {title && <StyledHeaderTitle>{title}</StyledHeaderTitle>}
        {centerComponent}
        <StyledHeaderAction>
          {menu && (
            <StyledHeaderActionColumn>
              <MenuDropdown {...menu} />
            </StyledHeaderActionColumn>
          )}
        </StyledHeaderAction>
      </StyledHeader>
    </>
  );
};

export default Header;
